import { resolveAssetUrl } from "../../../helpers"
import { StoreStyleProps } from "./link-row"
import { DefaultStyle } from "./default-style"

// Классическая раскладка поверх размытой и затемнённой картинки на весь экран
export const BlurStyle = (props: StoreStyleProps) => {
    const {data, className} = props
    if (!data.image) return <DefaultStyle {...props} />

    return (
        <>
            <div className="get-qr-backdrop" aria-hidden="true">
                <img className="get-qr-backdrop-image" src={resolveAssetUrl(data.image)} alt="" />
            </div>
            <DefaultStyle {...props} className={`get-qr-card-blur${className ? ` ${className}` : ''}`} />
        </>
    )
}
